var _path, _g, _g2, _path2, _g3, _g4, _g5, _g6, _g7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 231,
    viewBox: "0 0 231 231",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2170_1364)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.183 56.049C98.5175 39.594 62.3939 34.0156 58.5162 43.5987L24.583 127.458C24.2727 128.225 24.3124 129.097 24.6934 129.882C25.0745 130.668 25.7657 131.302 26.6149 131.645C27.4641 131.989 28.4018 132.014 29.2218 131.715C30.0417 131.415 30.6767 130.816 30.987 130.049C33.3728 124.153 63.0331 126.191 104.08 142.8C145.126 159.409 167.857 178.571 165.471 184.468C165.161 185.235 165.2 186.107 165.582 186.892C165.963 187.677 166.654 188.311 167.503 188.655C168.352 188.999 169.29 189.024 170.11 188.724C170.93 188.425 171.565 187.826 171.875 187.059L205.808 103.2C209.686 93.6166 179.848 72.5041 139.183 56.049Z",
    fill: "url(#paint0_linear_2170_1364)"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 5.26569,
    y: 19.7949,
    width: 218.676,
    height: 190.542
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(3px)",
      clipPath: "url(#bgblur_1_2170_1364_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2170_1364)",
    "data-figma-bg-blur-radius": 6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.101 43.895C98.8016 25.5649 58.186 20.2794 53.4028 32.1L11.5467 135.539C11.1639 136.485 11.1725 137.545 11.5708 138.484C11.969 139.424 12.7242 140.167 13.6702 140.55C14.6162 140.932 15.6755 140.924 16.6151 140.525C17.5547 140.127 18.2976 139.372 18.6804 138.426C21.6233 131.153 55.0776 132.399 100.801 150.901C146.525 169.403 171.432 191.772 168.489 199.045C168.106 199.991 168.115 201.051 168.513 201.99C168.912 202.93 169.667 203.673 170.613 204.056C171.559 204.438 172.618 204.43 173.558 204.031C174.497 203.633 175.24 202.878 175.623 201.932L217.479 98.4926C222.262 86.6719 189.4 62.2251 144.101 43.895Z",
    fill: "url(#paint1_linear_2170_1364)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.686 44.9207C166.274 54.0609 185.726 64.7127 198.91 74.5223C205.51 79.4323 210.487 84.0933 213.51 88.2078C216.576 92.3805 217.421 95.6875 216.453 98.0775L174.597 201.517C174.325 202.191 173.795 202.729 173.126 203.013C172.457 203.296 171.702 203.302 171.028 203.03C170.354 202.757 169.816 202.228 169.532 201.558C169.248 200.889 169.242 200.134 169.514 199.46C170.024 198.2 169.879 196.75 169.341 195.27C168.799 193.78 167.817 192.135 166.46 190.38C163.743 186.865 159.394 182.742 153.566 178.304C141.898 169.419 124.15 159.155 101.216 149.875C78.2827 140.595 58.3917 135.629 43.8284 133.9C36.554 133.036 30.5614 132.974 26.1648 133.61C23.969 133.928 22.1193 134.427 20.6939 135.121C19.2778 135.81 18.1654 136.751 17.6554 138.011C17.3826 138.685 16.8527 139.223 16.1832 139.507C15.5138 139.79 14.7592 139.796 14.0852 139.524C13.4112 139.251 12.8731 138.722 12.5893 138.052C12.3057 137.383 12.2996 136.628 12.5723 135.954L54.4285 32.515C55.3956 30.125 58.3023 28.3358 63.4073 27.4696C68.4412 26.6154 75.2591 26.7271 83.4158 27.788C99.7122 29.9078 121.098 35.7804 143.686 44.9207Z",
    stroke: "url(#paint2_linear_2170_1364)",
    strokeOpacity: 0.1,
    strokeWidth: 2.2125
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_2170_1364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.445 114.623C160.195 113.434 154.156 85.3255 131.11 76.0002C108.065 66.675 84.1777 82.6742 83.1718 83.3547C82.5436 83.7826 82.0561 84.387 81.771 85.0917C81.4859 85.7963 81.4158 86.5696 81.5697 87.314C81.8193 88.5025 87.8584 116.611 110.904 125.936C133.95 135.262 157.837 119.262 158.843 118.582C159.471 118.154 159.958 117.55 160.243 116.845C160.528 116.14 160.598 115.367 160.445 114.623Z",
    fill: "white",
    fillOpacity: 0.16
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.676 111.667C122.586 114.059 129.315 111.206 131.707 105.297C134.098 99.3868 131.246 92.6574 125.336 90.266C119.426 87.8746 112.697 90.7269 110.305 96.6367C107.914 102.546 110.766 109.276 116.676 111.667Z",
    fill: "url(#paint3_linear_2170_1364)"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 95.7654,
    y: 75.7246,
    width: 50.4884,
    height: 50.4888
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(3px)",
      clipPath: "url(#bgblur_2_2170_1364_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_2170_1364)",
    "data-figma-bg-blur-radius": 6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.793 118.803C123.643 122.789 134.858 118.035 138.844 108.186C142.83 98.3359 138.076 87.1202 128.226 83.1346C118.377 79.1489 107.161 83.9027 103.175 93.7523C99.1897 103.602 103.943 114.818 113.793 118.803Z",
    fill: "url(#paint4_linear_2170_1364)",
    fillOpacity: 0.2
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_2170_1364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.676 111.667C122.586 114.059 129.315 111.206 131.707 105.297C134.098 99.3868 131.246 92.6574 125.336 90.266C119.426 87.8746 112.697 90.7269 110.305 96.6367C107.914 102.546 110.766 109.276 116.676 111.667Z",
    fill: "url(#paint5_linear_2170_1364)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 4.9267,
    y: 26.1001,
    width: 75.5831,
    height: 143.658
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(3px)",
      clipPath: "url(#bgblur_3_2170_1364_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_2170_1364)",
    "data-figma-bg-blur-radius": 6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.9159 58.1355L72.6203 57.9121C58.5071 47.6644 50.9345 38.1995 53.4026 32.1001L11.7124 135.129C8.71173 142.545 14.3148 151.902 28.3662 162.938C28.8355 163.306 29.3838 163.56 29.9681 163.68C30.5523 163.8 31.1564 163.782 31.7326 163.629C32.3088 163.475 32.8415 163.189 33.2885 162.795C33.7354 162.4 34.0845 161.906 34.3081 161.354L74.2288 62.6973C74.5516 61.8996 74.5977 61.0168 74.3597 60.1898C74.1217 59.3629 73.6133 58.6396 72.9159 58.1355Z",
    fill: "url(#paint6_linear_2170_1364)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3454 37.6624C52.9954 39.7366 54.2362 41.9121 55.9124 44.1193C59.3517 48.6481 64.8647 53.6449 71.9533 58.7936L71.953 58.7945L72.2489 59.0186L72.2578 59.0253L72.2676 59.0325C72.7645 59.3916 73.1271 59.9068 73.2966 60.496C73.4661 61.085 73.4337 61.7139 73.2039 62.2821L33.2829 160.939C33.1236 161.333 32.8741 161.684 32.5556 161.966C32.2372 162.247 31.8578 162.45 31.4474 162.559C31.0369 162.669 30.6066 162.682 30.1904 162.596C29.826 162.522 29.4813 162.373 29.1768 162.162L29.0493 162.068C22.0705 156.587 17.2762 151.586 14.5939 147.107C11.9214 142.645 11.411 138.824 12.738 135.544L52.3454 37.6624Z",
    stroke: "url(#paint7_linear_2170_1364)",
    strokeOpacity: 0.1,
    strokeWidth: 2.2125
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 135.033,
    y: 92.4946,
    width: 88.4456,
    height: 123.977
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(3px)",
      clipPath: "url(#bgblur_4_2170_1364_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_2170_1364)",
    "data-figma-bg-blur-radius": 6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.351 103.634L185.719 103.679C202.987 106.129 215.011 104.594 217.479 98.4948L175.789 201.524C172.788 208.94 162.255 211.767 144.482 209.926C143.889 209.864 143.318 209.665 142.815 209.345C142.312 209.025 141.89 208.592 141.583 208.081C141.276 207.57 141.092 206.994 141.045 206.4C140.998 205.805 141.091 205.208 141.314 204.655L181.235 105.999C181.558 105.201 182.139 104.535 182.885 104.106C183.631 103.677 184.499 103.511 185.351 103.634Z",
    fill: "url(#paint8_linear_2170_1364)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.764 201.109C173.436 204.389 170.412 206.779 165.388 208.127C160.661 209.396 154.281 209.704 146.229 208.984L144.596 208.826C144.174 208.782 143.767 208.64 143.409 208.412C143.051 208.183 142.75 207.875 142.531 207.511C142.313 207.147 142.181 206.737 142.148 206.314C142.115 205.89 142.181 205.464 142.34 205.07L182.261 106.414C182.491 105.845 182.905 105.371 183.436 105.066C183.968 104.76 184.586 104.642 185.193 104.729L185.217 104.732L185.584 104.777L185.584 104.776C194.259 106.005 201.695 106.249 207.317 105.386C210.057 104.966 212.462 104.265 214.371 103.226L174.764 201.109Z",
    stroke: "url(#paint9_linear_2170_1364)",
    strokeOpacity: 0.1,
    strokeWidth: 2.2125
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_2170_1364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.315 94.5131C117.285 95.3102 119.529 94.3595 120.326 92.3895C121.123 90.4196 120.172 88.1765 118.202 87.3794C116.232 86.5822 113.989 87.533 113.192 89.5029C112.395 91.4728 113.346 93.716 115.315 94.5131Z",
    fill: "white",
    fillOpacity: 0.16
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2170_1364",
    x: 5.26569,
    y: 19.7949,
    width: 218.676,
    height: 190.542,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2170_1364"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_2170_1364_clip_path",
    transform: "translate(-5.26569 -19.7949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.101 43.895C98.8016 25.5649 58.186 20.2794 53.4028 32.1L11.5467 135.539C11.1639 136.485 11.1725 137.545 11.5708 138.484C11.969 139.424 12.7242 140.167 13.6702 140.55C14.6162 140.932 15.6755 140.924 16.6151 140.525C17.5547 140.127 18.2976 139.372 18.6804 138.426C21.6233 131.153 55.0776 132.399 100.801 150.901C146.525 169.403 171.432 191.772 168.489 199.045C168.106 199.991 168.115 201.051 168.513 201.99C168.912 202.93 169.667 203.673 170.613 204.056C171.559 204.438 172.618 204.43 173.558 204.031C174.497 203.633 175.24 202.878 175.623 201.932L217.479 98.4926C222.262 86.6719 189.4 62.2251 144.101 43.895Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_2170_1364",
    x: 81.4901,
    y: 73.0889,
    width: 79.0342,
    height: 57.7588,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2170_1364"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_2170_1364",
    x: 95.7654,
    y: 75.7246,
    width: 50.4884,
    height: 50.4888,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2170_1364"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_2_2170_1364_clip_path",
    transform: "translate(-95.7654 -75.7246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.793 118.803C123.643 122.789 134.858 118.035 138.844 108.186C142.83 98.3359 138.076 87.1202 128.226 83.1346C118.377 79.1489 107.161 83.9027 103.175 93.7523C99.1897 103.602 103.943 114.818 113.793 118.803Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_2170_1364",
    x: 109.459,
    y: 89.4199,
    width: 23.0931,
    height: 25.0933,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2170_1364"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_2170_1364",
    x: 4.9267,
    y: 26.1001,
    width: 75.5831,
    height: 143.658,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2170_1364"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_3_2170_1364_clip_path",
    transform: "translate(-4.9267 -26.1001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.9159 58.1355L72.6203 57.9121C58.5071 47.6644 50.9345 38.1995 53.4026 32.1001L11.7124 135.129C8.71173 142.545 14.3148 151.902 28.3662 162.938C28.8355 163.306 29.3838 163.56 29.9681 163.68C30.5523 163.8 31.1564 163.782 31.7326 163.629C32.3088 163.475 32.8415 163.189 33.2885 162.795C33.7354 162.4 34.0845 161.906 34.3081 161.354L74.2288 62.6973C74.5516 61.8996 74.5977 61.0168 74.3597 60.1898C74.1217 59.3629 73.6133 58.6396 72.9159 58.1355Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_2170_1364",
    x: 135.033,
    y: 92.4946,
    width: 88.4456,
    height: 123.977,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2170_1364"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_4_2170_1364_clip_path",
    transform: "translate(-135.033 -92.4946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.351 103.634L185.719 103.679C202.987 106.129 215.011 104.594 217.479 98.4948L175.789 201.524C172.788 208.94 162.255 211.767 144.482 209.926C143.889 209.864 143.318 209.665 142.815 209.345C142.312 209.025 141.89 208.592 141.583 208.081C141.276 207.57 141.092 206.994 141.045 206.4C140.998 205.805 141.091 205.208 141.314 204.655L181.235 105.999C181.558 105.201 182.139 104.535 182.885 104.106C183.631 103.677 184.499 103.511 185.351 103.634Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_2170_1364",
    x: 112.91,
    y: 87.0972,
    width: 7.69769,
    height: 9.69775,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2170_1364"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2170_1364",
    x1: 65.5369,
    y1: 26.2485,
    x2: 205.335,
    y2: 151.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2339FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2170_1364",
    x1: 62.0627,
    y1: 10.6987,
    x2: 223.768,
    y2: 146.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#85A0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2170_1364",
    x1: 64.8283,
    y1: 18.6102,
    x2: 223.777,
    y2: 82.928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2170_1364",
    x1: 114.635,
    y1: 85.936,
    x2: 137.255,
    y2: 102.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2339FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2170_1364",
    x1: 110.392,
    y1: 75.918,
    x2: 148.091,
    y2: 103.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#85A0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2170_1364",
    x1: 114.635,
    y1: 85.936,
    x2: 137.255,
    y2: 102.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2339FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2170_1364",
    x1: 53.4026,
    y1: 32.1001,
    x2: 88.194,
    y2: 48.6571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#85A0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2170_1364",
    x1: 52.0637,
    y1: 37.9734,
    x2: 79.707,
    y2: 49.1591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2170_1364",
    x1: 188.944,
    y1: 86.9482,
    x2: 223.735,
    y2: 103.505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#85A0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2170_1364",
    x1: 187.605,
    y1: 92.8215,
    x2: 215.248,
    y2: 104.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2170_1364"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 177,
    height: 177,
    fill: "white",
    transform: "translate(66.3926) rotate(22.0304)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrace);
export default __webpack_public_path__ + "static/media/brace.86b7fa8ee507fc467158fa7f453064d1.svg";
export { ForwardRef as ReactComponent };